// https://vuex.vuejs.org/en/actions.html

import wrapper from 'axios-cache-plugin'
import Vue from 'vue'

export default {
  async logged ({ commit }, user) {
    return new Promise((resolve) => {
      commit('logged', user)
      resolve()
    })
  },
  async cleanRequestCache ({ commit }) {
    return new Promise((resolve) => {
      let http = wrapper(Vue.prototype.$http)

      http.__removeFilter(/overview/)
      http.__removeFilter(/affiliates/)
      http.__removeFilter(/adspaces/)
      http.__removeFilter(/campaigns/)
      http.__removeFilter(/general/)

      resolve()
    })
  },
  async logout ({ commit }) {
    return new Promise((resolve) => {
      commit('logout')
      resolve()
    })
  }
}
